import React, { useState, useEffect } from 'react';
import './TaxInvoice.css';
import { API_URL } from './API';
import { 
  Document, 
  Packer, 
  Paragraph, 
  TextRun, 
  Table, 
  NumberFormat,
  PageNumber,
  TableRow, 
  TableCell, 
  WidthType, 
  BorderStyle, 
  AlignmentType, 
  VerticalAlign,
  ImageRun
} from 'docx';

const PerformaInvoice = ({onBack}) => {
  const initialInvoiceData = {
    poNo: '',
    poDate: '',
    olaNo: '',
    invoiceDate: '',
    invoiceNo: ''
  };

  const initialVendorDetails = {
    name: 'PIE POWER PRIVATE LIMITED',
    address: 'D.NO :13-66, Mangamaripeta, Bheemunipatnam, Visakhapatam, Andhra Pradesh - 531163',

    phone: 'Ph : +91 9154110395, +91 8186084709',
    email: 'info@piepower.in',
    gst_no: '37AALCP9321R1ZI',
    vendorCode: '',
    state: 'Andhra Pradesh'
  };

  const initialBilledTo = {
    name: '',
    address: '',
    gstNo: '',
    gstStatus: 'Active'
  };

  const initialItems = [
    {
      id: 1,
      description: '',
      serviceCode: '',
      unit: '',
      unitPrice: '',
      qty: 0,
      amount: 0.00
    }
  ];

  const [invoiceData, setInvoiceData] = useState(initialInvoiceData);
  const [vendorDetails, setVendorDetails] = useState(initialVendorDetails);
  const [billedTo, setBilledTo] = useState(initialBilledTo);
  const [items, setItems] = useState(initialItems);
  const [isLoading, setIsLoading] = useState(false);
  const [currentInvoiceId, setCurrentInvoiceId] = useState(null);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [availableInvoices, setAvailableInvoices] = useState([]);

  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [allEntities, setAllEntities] = useState([]);
  const [activeSearchField, setActiveSearchField] = useState(null);
  

 const [lastInvoiceNumber, setLastInvoiceNumber] = useState(null);

  const [calculations, setCalculations] = useState({
    grossAmount: 0,
    roundOff: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    totalTax: 0,
    grandTotal: 0
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.tax-18')) {
        setShowSearchDropdown(false);
        setActiveSearchField(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



useEffect(() => {
  const loadLastInvoiceNumber = async () => {
    try {
      const result = await window.storage.get('last-performa-invoice-number');
      if (result && result.value) {
        setLastInvoiceNumber(parseInt(result.value));
      } else {
        setLastInvoiceNumber(0); 
      }
    } catch (error) {
      
      setLastInvoiceNumber(0);
    }
  };
  
  loadLastInvoiceNumber();
}, []);

useEffect(() => {
  const autoFillInvoiceNumber = async () => {
    if (!invoiceData.invoiceNo) {
      const nextInvoiceNum = await generateNextInvoiceNumber();
      setInvoiceData(prev => ({
        ...prev,
        invoiceNo: nextInvoiceNum
      }));
    }
  };
  
  autoFillInvoiceNumber();
}, []);

useEffect(() => {
  if (lastInvoiceNumber === null) return;

  if (!isUpdateMode) {
    generateNextInvoiceNumber();
  }
}, [isUpdateMode, lastInvoiceNumber]);


const generateNextInvoiceNumber = async () => {
  try {
    let stored = localStorage.getItem("last-performa-invoice-number");
    let currentNumber = stored ? parseInt(stored) : 0;

    const nextNumber = currentNumber + 1;
    const formatted = nextNumber.toString().padStart(2, '0');
    const yearSuffix = new Date().getFullYear().toString().slice(-2);

    setInvoiceData(prev => ({
      ...prev,
      invoiceNo: `PI/2256/${yearSuffix}/${formatted}`
    }));

   
  } catch (e) {
    
  }
};

useEffect(() => {
  const fetchAllEntities = async () => {
    try {
      const [vendorsResponse, clientsResponse] = await Promise.all([
        fetch(`${API_URL}/vendors/get_vendor`),
        fetch(`${API_URL}/clients/get_client`)
      ]);

      const vendorsData = await vendorsResponse.json();
      const clientsData = await clientsResponse.json();

      const entities = [];

      if (vendorsData.status === 'success' && vendorsData.data) {
        vendorsData.data.forEach(vendor => {
          entities.push({
            type: 'Vendor',
            name: vendor.vendor_name || vendor.name,
            gstNo: vendor.gst_no,
            address: vendor.address,
            state: vendor.state
          });
        });
      }

      if (clientsData.status === 'success' && clientsData.data) {
        clientsData.data.forEach(client => {
          entities.push({
            type: 'Client',
            name: client.client_name || client.name,
            gstNo: client.gst_no,
            address: client.address,
            state: client.state
          });
        });
      }

      setAllEntities(entities);
    } catch (error) {
      
    }
  };

  fetchAllEntities();
}, []);

  useEffect(() => {
    calculateTotals();
  }, [items, billedTo.gstNo]);

  const fetchAvailableInvoices = async () => {
    try {
    const response = await fetch(`${API_URL}/performainvoices/get_performainvoice`);
      const result = await response.json();
      
      if (response.ok && result.status === 'success') {
        setAvailableInvoices(result.data || []);
      } else {
        
      }
    } catch (error) {
      
    }
  };

  const loadInvoiceForUpdate = async (invoiceId) => {
    if (!invoiceId) return;
    
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/performainvoices/get_performainvoice?invoice_id=${invoiceId}`);
      const result = await response.json();

      if (response.ok && result.status === 'success') {
        const data = result.data;
        
        setInvoiceData({
          poNo: data.po_no || '',
          poDate: formatDateForInput(data.po_date) || '',
          olaNo: data.ola_no || '',
          invoiceDate: formatDateForInput(data.invoice_date) || '',
          invoiceNo: data.invoice_no || ''
        });

        setBilledTo({
          name: data.billed_name || '',
          address: data.billed_address || '',
          gstNo: data.billed_gst_no || '',
          gstStatus: data.gst_status || 'Active'
        });

        if (data.items && data.items.length > 0) {
          const loadedItems = data.items.map((item, index) => ({
            id: index + 1,
            description: item.description || '',
            serviceCode: item.service_code || '',
            unit: item.uom || 'EA',
            unitPrice: parseFloat(item.rate) || '',
            qty: parseInt(item.quantity) || 0,
            amount: parseFloat(item.amount) || 0
          }));
          setItems(loadedItems);
        }

        setCurrentInvoiceId(invoiceId);
        setIsUpdateMode(true);
        alert('Performa Invoice data loaded successfully for update!');
      } else {
        throw new Error(result.message || 'Failed to load invoice');
      }
    } catch (error) {
    
      alert('Error loading invoice: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBilledToSearch = (field, value) => {
    updateBilledTo(field, value);
    setActiveSearchField(field);

    if (value.trim().length < 1) {
      setSearchResults([]);
      setShowSearchDropdown(false);
      return;
    }

    setIsSearching(true);
    const searchValue = value.toLowerCase().trim();

    const filtered = allEntities.filter(entity => {
      if (field === 'name') {
        return entity.name && entity.name.toLowerCase().includes(searchValue);
      } else if (field === 'gstNo') {
        return entity.gstNo && entity.gstNo.toLowerCase().includes(searchValue);
      }
      return false;
    });

    setSearchResults(filtered);
    setShowSearchDropdown(filtered.length > 0);
    setIsSearching(false);
  };

  const handleSelectEntity = (entity) => {
    setBilledTo({
      name: entity.name || '',
      address: entity.address || '',
      gstNo: entity.gstNo || '',
      gstStatus: 'Active'
    });
    setSearchResults([]);
    setShowSearchDropdown(false);
    setActiveSearchField(null);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    
    if (dateString.includes('-') && dateString.split('-')[0].length === 2) {
      const [day, month, year] = dateString.split('-');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch (error) {
      return '';
    }
  };

  const isIntraState = () => {
    if (!billedTo.gstNo || billedTo.gstNo.length < 2) return false;
    return billedTo.gstNo.substring(0, 2) === '37';
  };

  const calculateTotals = () => {
    const grossAmount = items.reduce((sum, item) => sum + item.amount, 0);
    const roundedGross = Math.round(grossAmount);
    const roundOff = roundedGross - grossAmount;
    
    let cgst = 0;
    let sgst = 0;
    let igst = 0;

    if (isIntraState()) {
      cgst = roundedGross * 0.09;
      sgst = roundedGross * 0.09;
    } else {
      igst = roundedGross * 0.18;
    }

    const totalTax = cgst + sgst + igst;
    const grandTotal = roundedGross + totalTax;

    setCalculations({
      grossAmount,
      roundOff,
      cgst,
      sgst,
      igst,
      totalTax,
      grandTotal
    });
  };

  const addItem = () => {
    const newItem = {
      id: Date.now(),
      description: '',
      serviceCode: '',
      unit: 'EA',
      unitPrice: '',
      qty: 0,
      amount: 0
    };
    setItems([...items, newItem]);
  };

  const updateItem = (id, field, value) => {
    const updatedItems = items.map(item => {
      if (item.id === id) {
        const updatedItem = { ...item, [field]: value };
        if (field === 'unitPrice' || field === 'qty') {
          const price = field === 'unitPrice' ? parseFloat(value) || 0 : parseFloat(updatedItem.unitPrice) || 0;
          const quantity = field === 'qty' ? (typeof value === 'string' ? parseFloat(value) || 0 : value) : parseFloat(updatedItem.qty) || 0;
          updatedItem.amount = price * quantity;
        }
        return updatedItem;
      }
      return item;
    });
    setItems(updatedItems);
  };

  const removeItem = (id) => {
    setItems(items.filter(item => item.id !== id));
  };

  const updateInvoiceData = (field, value) => {
    setInvoiceData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const updateBilledTo = (field, value) => {
    setBilledTo(prev => ({
      ...prev,
      [field]: value
    }));
  };

const resetForm = async () => {
  setInvoiceData(prev => ({
    ...initialInvoiceData,
    invoiceNo: prev.invoiceNo  
  }));

  setBilledTo({ ...initialBilledTo });
  setItems([...initialItems]);
  setVendorDetails({ ...initialVendorDetails });
  setCurrentInvoiceId(null);
  setIsUpdateMode(false);

  await generateNextInvoiceNumber();
};


  const formatDateForApi = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const validateForm = () => {
    const errors = [];
    
    if (!invoiceData.invoiceNo.trim()) errors.push('Invoice number is required');
    if (!billedTo.name.trim()) errors.push('Billed To name is required');
    if (!billedTo.gstNo.trim()) errors.push('GST No is required');
    if (items.length === 0) errors.push('At least one item is required');
    
    items.forEach((item, index) => {
      if (!item.description.trim()) errors.push(`Item ${index + 1}: Description is required`);
      if (!item.unitPrice || parseFloat(item.unitPrice) <= 0) errors.push(`Item ${index + 1}: Rate must be greater than 0`);
      if (!item.qty || item.qty <= 0) errors.push(`Item ${index + 1}: Quantity must be greater than 0`);
    });

    return errors;
  };

  const numberToWords = (num) => {
    const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
    const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    if (num === 0) return 'Zero';

    function convertTwoDigits(num) {
      if (num === 0) return '';
      if (num < 10) return ones[num];
      if (num < 20) return teens[num - 10];
      const tensPart = tens[Math.floor(num / 10)];
      const onesPart = ones[num % 10];
      return tensPart + (onesPart ? ' ' + onesPart : '');
    }

    function convertHundreds(num) {
      if (num === 0) return '';
      const hundreds = Math.floor(num / 100);
      const remainder = num % 100;
      let result = '';
      
      if (hundreds > 0) {
        result = ones[hundreds] + ' Hundred';
        if (remainder > 0) result += ' and ';
      }
      
      if (remainder > 0) {
        result += convertTwoDigits(remainder);
      }
      
      return result;
    }

    let result = '';
    let crore = Math.floor(num / 10000000);
    num = num % 10000000;
    
    let lakh = Math.floor(num / 100000);
    num = num % 100000;
    
    let thousand = Math.floor(num / 1000);
    num = num % 1000;
    
    let hundred = num;

    if (crore > 0) {
      result += convertTwoDigits(crore) + ' Crore ';
    }
    
    if (lakh > 0) {
      result += convertTwoDigits(lakh) + ' Lakh ';
    }
    
    if (thousand > 0) {
      result += convertTwoDigits(thousand) + ' Thousand ';
    }
    
    if (hundred > 0) {
      result += convertHundreds(hundred);
    }

    return result.trim();
  };

const handleSave = async () => {
  const validationErrors = validateForm();
  if (validationErrors.length > 0) {
    alert('Please fix the following errors:\n' + validationErrors.join('\n'));
    return;
  }

  setIsLoading(true);

  try {
    const processedItems = items.map((item, index) => ({
      sno: index + 1,
      description: item.description || '',
      service_code: item.serviceCode || '',
      uom: item.unit || 'EA',
      rate: parseFloat(item.unitPrice) || 0,
      quantity: parseFloat(item.qty) || 0,
      amount: parseFloat(item.amount) || 0
    }));

    const payload = {
      vendor_name: vendorDetails.name,
      vendor_address: vendorDetails.address,
      vendor_gst_no: vendorDetails.gst_no,
      vendor_code: vendorDetails.vendorCode,
      vendor_phone: vendorDetails.phone,
      vendor_email: vendorDetails.email,
      vendor_state: vendorDetails.state,

      po_no: invoiceData.poNo,
      po_date: formatDateForApi(invoiceData.poDate),
      ola_no: invoiceData.olaNo,
      invoice_date: formatDateForApi(invoiceData.invoiceDate),
      performa_invoice_no: invoiceData.invoiceNo,

      billed_name: billedTo.name,
      billed_address: billedTo.address,
      billed_gst_no: billedTo.gstNo,
      billed_pan_no: billedTo.panNo || '',
      billed_state: billedTo.state || vendorDetails.state,

      line_items: processedItems,

      gross_amount: parseFloat(calculations.grossAmount) || 0,
      igst_amount: parseFloat(calculations.igst) || 0,
      cgst_amount: parseFloat(calculations.cgst) || 0,
      sgst_amount: parseFloat(calculations.sgst) || 0,
      grand_total: parseFloat(calculations.grandTotal) || 0
    };

    

    let response;
    let endpoint;

    if (isUpdateMode && currentInvoiceId) {
      endpoint = `${API_URL}/performainvoices/update_performainvoice`;
      payload.invoice_id = currentInvoiceId;
      
      response = await fetch(endpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
    } else {
   
      endpoint = `${API_URL}/performainvoices/create_performainvoice`;
      
      response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });
    }

    const result = await response.json();

    if (response.ok && result.status === 'success') {
      const action = isUpdateMode ? 'updated' : 'saved';
      alert(`Performa Invoice ${action} successfully!`);
     
      
    } else {
      throw new Error(result.message || `Failed to ${isUpdateMode ? 'update' : 'save'} performa invoice`);
    }
  } catch (error) {
    
    alert(`Error ${isUpdateMode ? 'updating' : 'saving'} performa invoice: ` + error.message);
  } finally {
    setIsLoading(false);
  }
};

  const handleUpdate = async () => {
    await fetchAvailableInvoices();
    
    if (availableInvoices.length === 0) {
      alert('No invoices found to update.');
      return;
    }

    const invoiceOptions = availableInvoices.map(invoice => 
      `${invoice.id}: ${invoice.invoice_no} - ${invoice.billed_name || 'Unknown'}`
    ).join('\n');
    
    const selectedId = prompt(
      `Select an invoice to update:\n${invoiceOptions}\n\nEnter the Invoice ID:`
    );

    if (selectedId) {
      const invoice = availableInvoices.find(inv => inv.id.toString() === selectedId.toString());
      if (invoice) {
        await loadInvoiceForUpdate(invoice.id);
      } else {
        alert('Invalid invoice ID selected.');
      }
    }
  };




    const generateTaxInvoiceWordBlob = (invoiceData, vendorDetails, billedTo, items, calculations, bankDetails) => {
  return new Promise(async (resolve, reject) => {
    try {
      const tableBorders = {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
      };

      const convertInchesToTwip = (inches) => {
        return Math.round(inches * 1440);
      };

      const safeToString = (value) => {
        if (value === null || value === undefined || value === '' || value === '-') {
          return "";
        }
        return value.toString();
      };

      const formatDateForDisplay = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB');
      };

      const isIntraState = () => {
        return billedTo.state === 'Andhra Pradesh';
      };

      const fetchImageAsBase64 = (url) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = function() {
            try {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              canvas.width = img.width;
              canvas.height = img.height;
              ctx.drawImage(img, 0, 0);
              const dataURL = canvas.toDataURL('image/png');
              const base64 = dataURL.split(',')[1];
              resolve(base64);
            } catch (error) {
             
              resolve(null);
            }
          };
          img.onerror = function() {
           
            resolve(null);
          };
          img.src = url;
        });
      };

      const logoUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const watermarkUrl = "https://i.ibb.co/BHKCMXV8/Whats-App-Image-2025-06-16-at-11-21-26-AM.jpg";
      const unionBankLogoUrl = "https://tse4.mm.bing.net/th/id/OIP.a8d0G4tonetyyygHVXoHcAHaHa?pid=Api&P=0&h=220";
      const signatureUrl = "https://i.ibb.co/RpzR0W0M/Signew-1.png";
      const stampUrl = "https://i.ibb.co/xqZ8CWFT/stamp.png";

      const logoBase64 = await fetchImageAsBase64(logoUrl);
      const watermarkBase64 = await fetchImageAsBase64(watermarkUrl);
      const unionBankLogoBase64 = await fetchImageAsBase64(unionBankLogoUrl);
      const signatureBase64 = await fetchImageAsBase64(signatureUrl);
      const stampBase64 = await fetchImageAsBase64(stampUrl);
      
      const documentSections = [];

     

      documentSections.push(
        new Paragraph({
          alignment: AlignmentType.CENTER,
          children: [
            new TextRun({
              text: "PERFORMA INVOICE",
              font: "Times New Roman",
              bold: true,
              size: 32,
              color: "#1e402c"
            })
          ],
          spacing: { before: 200, after: 200 }
        })
      );



documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: {
      top: { style: BorderStyle.NONE },
      bottom: { style: BorderStyle.NONE },
      left: { style: BorderStyle.NONE },
      right: { style: BorderStyle.NONE },
      insideHorizontal: { style: BorderStyle.NONE },
      insideVertical: { style: BorderStyle.NONE },
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({ text: "" }), 
            ],
            borders: {
              top: { style: BorderStyle.NONE },
              bottom: { style: BorderStyle.NONE },
              left: { style: BorderStyle.NONE },
              right: { style: BorderStyle.NONE },
            },
            width: { size: 60, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                children: [
                  new TextRun({
                    text: `Invoice No: ${safeToString(invoiceData.invoiceNo)}`,
                    font: "Courier New",
                    bold: true,
                    size: 22,
                  }),
                ],
              }),
              new Paragraph({
                alignment: AlignmentType.RIGHT,
                spacing: { before: 100 },
                children: [
                  new TextRun({
                    text: `Date: ${formatDateForDisplay(invoiceData.invoiceDate)}`,
                    font: "Courier New",
                    bold: true,
                    size: 22,
                  }),
                ],
              }),
            ],
            borders: {
              top: { style: BorderStyle.NONE },
              bottom: { style: BorderStyle.NONE },
              left: { style: BorderStyle.NONE },
              right: { style: BorderStyle.NONE },
            },
            width: { size: 40, type: WidthType.PERCENTAGE },
          }),
        ],
      }),
    ],
  })
);

documentSections.push(new Paragraph({ text: "" }));



documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: {
      top: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
      bottom: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
      left: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
      right: { style: BorderStyle.SINGLE, size: 6, color: "000000" },
      insideHorizontal: { style: BorderStyle.NONE },
      insideVertical: { style: BorderStyle.SINGLE, size: 6, color: "000000" }
    },
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "VENDOR DETAILS",
                    font: "Courier New",
                    bold: true,
                    size: 20
                  })
                ],
                spacing: {
                  after: 100
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: safeToString(vendorDetails.name),
                    font: "Courier New",
                    bold: true,
                    size: 18
                  })
                ],
                spacing: {
                  after: 80
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Address: ${safeToString(vendorDetails.address)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
             
              new Paragraph({
                children: [
                  new TextRun({
                    text: `GST: ${safeToString(vendorDetails.gst_no)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Vendor Code: ${safeToString(vendorDetails.vendorCode)}`,
                    font: "Courier New",
                    size: 16
                  })
                ]
              })
            ],
            width: { size: 50, type: WidthType.PERCENTAGE },
            margins: {
              top: convertInchesToTwip(0.15),
              bottom: convertInchesToTwip(0.15),
              left: convertInchesToTwip(0.15),
              right: convertInchesToTwip(0.15)
            },
            verticalAlign: VerticalAlign.TOP
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "BILLED TO",
                    font: "Courier New",
                    bold: true,
                    size: 20
                  })
                ],
                spacing: {
                  after: 100
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: safeToString(billedTo.name),
                    font: "Courier New",
                    bold: true,
                    size: 18
                  })
                ],
                spacing: {
                  after: 80
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `PO No.: ${safeToString(invoiceData.poNo)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `PO Date: ${formatDateForDisplay(invoiceData.poDate)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `OLA No.: ${safeToString(invoiceData.olaNo)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Address: ${safeToString(billedTo.address)}`,
                    font: "Courier New",
                    size: 16
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `GST: ${safeToString(billedTo.gstNo)}`,
                    font: "Courier New",
                    size: 16,
                    bold: true
                  })
                ],
                spacing: {
                  after: 60
                }
              }),
            
            ],
            width: { size: 50, type: WidthType.PERCENTAGE },
            margins: {
              top: convertInchesToTwip(0.15),
              bottom: convertInchesToTwip(0.15),
              left: convertInchesToTwip(0.15),
              right: convertInchesToTwip(0.15)
            },
            verticalAlign: VerticalAlign.TOP
          })
        ]
      })
    ]
  })
);

documentSections.push(new Paragraph({ text: "" }));



      const itemsTableRows = [
        new TableRow({
          children: [
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "S.No.", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 8, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Description of Work", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 35, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Service Code", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 15, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "UOM", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 8, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Rate (Rs.)", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 12, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Qty.", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 8, type: WidthType.PERCENTAGE }
            }),
            new TableCell({
              children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: "Amount (Rs.)", font: "Courier New", bold: true })] })],
              borders: tableBorders,
              shading: { fill: "a6a6a6" },
              width: { size: 14, type: WidthType.PERCENTAGE }
            })
          ]
        })
      ];

      items.forEach((item, index) => {
        itemsTableRows.push(
          new TableRow({
            children: [
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: (index + 1).toString(), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.LEFT, children: [new TextRun({ text: safeToString(item.description), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: safeToString(item.serviceCode), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
  children: [new Paragraph({ 
    alignment: AlignmentType.CENTER, 
    children: [new TextRun({ 
      text: item.unit || item.uom || 'EA', 
      font: "Courier New",
      size: 18
    })] 
  })],
  borders: tableBorders,
  width: { size: 8, type: WidthType.PERCENTAGE }
}),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: parseFloat(item.unitPrice).toFixed(2), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new TextRun({ text: item.qty.toString(), font: "Courier New" })] })],
                borders: tableBorders
              }),
              new TableCell({
                children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: item.amount.toFixed(2), font: "Courier New" })] })],
                borders: tableBorders
              })
            ]
          })
        );
      });

      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: itemsTableRows
        })
      );

      documentSections.push(new Paragraph({ text: "" }));

      const taxRows = [
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "Taxable Amount:", font: "Courier New", bold: true })] })],
        borders: {
          top: { style: BorderStyle.NONE },
          bottom: { style: BorderStyle.NONE },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        },
        width: { size: 70, type: WidthType.PERCENTAGE }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${Math.round(calculations.grossAmount).toFixed(2)}`, font: "Courier New", bold: true })] })],
        borders: {
          top: { style: BorderStyle.NONE },
          bottom: { style: BorderStyle.NONE },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        },
        width: { size: 30, type: WidthType.PERCENTAGE }
      })
    ]
  }),
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "Roundoff:", font: "Courier New" })] })],
        borders: {
          top: { style: BorderStyle.NONE },
          bottom: { style: BorderStyle.NONE },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${calculations.roundOff.toFixed(2)}`, font: "Courier New" })] })],
        borders: {
          top: { style: BorderStyle.NONE },
          bottom: { style: BorderStyle.NONE },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        }
      })
    ]
  })
];

if (isIntraState()) {
  taxRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "CGST @ 9%:", font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${calculations.cgst.toFixed(2)}`, font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        })
      ]
    }),
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "SGST @ 9%:", font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${calculations.sgst.toFixed(2)}`, font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        })
      ]
    })
  );
} else {
  taxRows.push(
    new TableRow({
      children: [
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "IGST @ 18%:", font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        }),
        new TableCell({
          children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${calculations.igst.toFixed(2)}`, font: "Courier New" })] })],
          borders: {
            top: { style: BorderStyle.NONE },
            bottom: { style: BorderStyle.NONE },
            left: { style: BorderStyle.NONE },
            right: { style: BorderStyle.NONE }
          }
        })
      ]
    })
  );
}

taxRows.push(
  new TableRow({
    children: [
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: "Grand Total:", font: "Courier New", bold: true, size: 24 })] })],
        borders: {
          top: { style: BorderStyle.SINGLE, size: 2 },
          bottom: { style: BorderStyle.SINGLE, size: 2 },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        }
      }),
      new TableCell({
        children: [new Paragraph({ alignment: AlignmentType.RIGHT, children: [new TextRun({ text: `₹ ${calculations.grandTotal.toFixed(2)}`, font: "Courier New", bold: true, size: 24 })] })],
        borders: {
          top: { style: BorderStyle.SINGLE, size: 2 },
          bottom: { style: BorderStyle.SINGLE, size: 2 },
          left: { style: BorderStyle.NONE },
          right: { style: BorderStyle.NONE }
        }
      })
    ]
  })
);

documentSections.push(
  new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    rows: taxRows,
    alignment: AlignmentType.RIGHT,
    borders: {
      top: { style: BorderStyle.NONE },
      bottom: { style: BorderStyle.NONE },
      left: { style: BorderStyle.NONE },
      right: { style: BorderStyle.NONE },
      insideHorizontal: { style: BorderStyle.NONE },
      insideVertical: { style: BorderStyle.NONE }
    }
  })
);
      documentSections.push(new Paragraph({ text: "" }));

      documentSections.push(
        new Paragraph({
          children: [
            new TextRun({
              text: "Amount in Words: ",
              font: "Courier New",
              bold: true,
              size: 20
            }),
            new TextRun({
              text: numberToWords(Math.floor(calculations.grandTotal)) + ' Rupees Only',
              font: "Courier New",
              size: 20
            })
          ],
          spacing: { before: 200, after: 200 }
        })
      );

      documentSections.push(
        new Table({
          width: { size: 100, type: WidthType.PERCENTAGE },
          rows: [
            new TableRow({
              children: [
                new TableCell({
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: "BANK DETAILS",
                          font: "Courier New",
                          bold: true,
                          size: 20,
                          color: "#1e402c"
                        })
                      ]
                    }),
                    ...(unionBankLogoBase64 ? [
                      new Paragraph({
                        children: [
                          new ImageRun({
                            data: unionBankLogoBase64,
                            transformation: {
                              width: 40,
                              height: 40
                            }
                          })
                        ],
                        alignment: AlignmentType.LEFT,
                        spacing: { before: 100, after: 100 }
                      })
                    ] : []),
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `Name: ${safeToString(bankDetails.Name)}`,
                          font: "Courier New",
                          size: 16
                        })
                      ]
                    }),
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `Bank Name: ${safeToString(bankDetails.bankName)}`,
                          font: "Courier New",
                          size: 16
                        })
                      ]
                    }),
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `Account No: ${safeToString(bankDetails.accountNo)}`,
                          font: "Courier New",
                          size: 16
                        })
                      ]
                    }),
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: `IFSC: ${safeToString(bankDetails.ifsc)}`,
                          font: "Courier New",
                          size: 16
                        })
                      ]
                    })
                  ],
                  borders: tableBorders,
                  width: { size: 50, type: WidthType.PERCENTAGE },
                  margins: {
                    top: convertInchesToTwip(0.1),
                    bottom: convertInchesToTwip(0.1),
                    left: convertInchesToTwip(0.1),
                    right: convertInchesToTwip(0.1)
                  }
                }),
new TableCell({
  children: [
    new Paragraph({
      children: [
        new TextRun({
          text: `For ${safeToString(vendorDetails.name)}`,
          font: "Courier New",
          bold: true,
          size: 18,
          color: "#1e402c"
        })
      ]
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: "",
          font: "Courier New",
          size: 16
        })
      ],
      spacing: { before: 100, after: 100 }
    }),
    
   ...(signatureBase64 || stampBase64 ? [

  new Table({

    rows: [

      new TableRow({

        children: [

          new TableCell({

            children: [

              new Paragraph({

                children: signatureBase64 ? [

                  new ImageRun({

                    data: signatureBase64,

                    transformation: {

                      width: 150,

                      height: 80

                    }

                  })

                ] : [new TextRun({ text: "" })],

                alignment: AlignmentType.CENTER

              })

            ],

            borders: {

              top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }

            },

            width: { size: 50, type: WidthType.PERCENTAGE }

          }),

          new TableCell({

            children: [

              new Paragraph({

                children: stampBase64 ? [

                  new ImageRun({

                    data: stampBase64,

                    transformation: {

                      width: 100,

                      height: 100

                    }

                  })

                ] : [new TextRun({ text: "" })],

                alignment: AlignmentType.CENTER

              })

            ],

            borders: {

              top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

              right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }

            },

            width: { size: 50, type: WidthType.PERCENTAGE }

          })

        ]

      })

    ],

    width: { size: 100, type: WidthType.PERCENTAGE },

    borders: {

      top: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

      bottom: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

      left: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

      right: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

      insideHorizontal: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" },

      insideVertical: { style: BorderStyle.NONE, size: 0, color: "FFFFFF" }

    },

    alignment: AlignmentType.CENTER

  })

] : [

  new Paragraph({

    children: [new TextRun({ text: "", size: 16 })],

    spacing: { before: 300, after: 300 }

  })

]),
 
    new Paragraph({
      children: [
        new TextRun({
          text: "Authorised Signatory",
          font: "Courier New",
          size: 16
        })
      ],
      spacing: { before: 100 }
    })
  ],
  borders: tableBorders,
  width: { size: 50, type: WidthType.PERCENTAGE },
  margins: {
    top: convertInchesToTwip(0.1),
    bottom: convertInchesToTwip(0.1),
    left: convertInchesToTwip(0.1),
    right: convertInchesToTwip(0.1)
  }
})
              ]
            })
          ]
        })
      );

      const footerTable = new Table({
        width: { size: 100, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.LEFT,
        rows: [
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "Pie Power",
                        font: "Courier New",
                        bold: true,
                        size: 18
                      })
                    ]
                  })
                ],
                borders: tableBorders,
                width: { size: 25, type: WidthType.PERCENTAGE },
                margins: {
                  top: convertInchesToTwip(0.25),
                  bottom: convertInchesToTwip(0.25),
                  left: convertInchesToTwip(0.25),
                  right: convertInchesToTwip(0.25)
                }
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "TPREL",
                        font: "Courier New",
                        bold: true,
                        size: 18
                      })
                    ]
                  })
                ],
                borders: tableBorders,
                width: { size: 25, type: WidthType.PERCENTAGE },
                margins: {
                  top: convertInchesToTwip(0.25),
                  bottom: convertInchesToTwip(0.25),
                  left: convertInchesToTwip(0.25),
                  right: convertInchesToTwip(0.25)
                }
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "TPREL",
                        font: "Courier New",
                        bold: true,
                        size: 18
                      })
                    ]
                  })
                ],
                borders: tableBorders,
                width: { size: 25, type: WidthType.PERCENTAGE },
                margins: {
                  top: convertInchesToTwip(0.25),
                  bottom: convertInchesToTwip(0.25),
                  left: convertInchesToTwip(0.25),
                  right: convertInchesToTwip(0.25)
                }
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: "TPREL",
                        font: "Courier New",
                        bold: true,
                        size: 18
                      })
                    ]
                  })
                ],
                borders: tableBorders,
                width: { size: 25, type: WidthType.PERCENTAGE },
                margins: {
                  top: convertInchesToTwip(0.25),
                  bottom: convertInchesToTwip(0.25),
                  left: convertInchesToTwip(0.25),
                  right: convertInchesToTwip(0.25)
                }
              })
            ]
          })
        ]
      });

      const documentPageBorders = {
        pageBorderTop: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderRight: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderBottom: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        },
        pageBorderLeft: {
          style: BorderStyle.DOUBLE,
          size: 6,
          color: "000000",
          space: 3
        }
      };

      const doc = new Document({
        sections: [
          {
            properties: {
              page: {
                margin: {
                  top: convertInchesToTwip(0.5),
                  right: convertInchesToTwip(0.5),
                  bottom: convertInchesToTwip(1.0),
                  left: convertInchesToTwip(0.5)
                },
                borders: documentPageBorders,
                pageNumbers: {
                  start: 1,
                  formatType: NumberFormat.DECIMAL
                }
              }
            },
            ...(watermarkBase64 && {
              background: {
                color: "FFFFFF"
              }
            }),
            children: documentSections
          }
        ]
      });

      Packer.toBlob(doc).then(blob => {
        resolve(blob);
      }).catch(error => {
       
        reject(error);
      });

    } catch (error) {
      
      reject(error);
    }
  });
};


const handleDownload = async () => {
  const validationErrors = validateForm();
  if (validationErrors.length > 0) {
    alert('Please fix the following errors before downloading:\n' + validationErrors.join('\n'));
    return;
  }

  try {
    setIsLoading(true);

    const bankDetails = {
      Name: 'PIE POWER PRIVATE LIMITED',
      bankName: 'Union Bank of India',
      accountNo: '474201010310113',
      ifsc: 'UBIN0547425'
    };

    const blob = await generateTaxInvoiceWordBlob(
      invoiceData,
      vendorDetails,
      billedTo,
      items,
      calculations,
      bankDetails
    );

    const currentInvoiceNum = invoiceData.invoiceNo;

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${currentInvoiceNum}.docx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    
    if (!isUpdateMode) {
      try {
        const invoiceNumParts = invoiceData.invoiceNo.split('/');
        const currentNum = parseInt(invoiceNumParts[invoiceNumParts.length - 1]);
        
        localStorage.setItem("last-performa-invoice-number", currentNum.toString());
        setLastInvoiceNumber(currentNum);
        
     
      } catch (error) {
       
      }
    }

    alert(`Performa Invoice downloaded successfully as ${currentInvoiceNum}`);
    
    await resetForm();
    
    if (onBack) {
      onBack(true); 
    }
    
  } catch (error) {
  
    alert('Error generating Word document: ' + error.message);
  } finally {
    setIsLoading(false);
  }
};


  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };
  return (
    <div className="tax-00">
      <div className="tax-01">
        <div className="tax-08">
          <h2 className="tax-09">PERFORMA INVOICE</h2>
          {isUpdateMode && (
            <div style={{ marginTop: '10px', padding: '8px', backgroundColor: '#e7f3ff', borderRadius: '4px', fontSize: '14px', color: '#0066cc' }}>
              <strong>Update Mode:</strong> Editing Invoice #{invoiceData.invoiceNo}
            </div>
          )}
        </div>

        <div className="tax-10">
          <div className="tax-11">
            <h3 className="tax-12">Vendor Details</h3>
            <div className="tax-13">
              <label>Name:</label>
              <input
                type="text"
                value={vendorDetails.name}
                className="tax-37"
                readOnly
              />
            </div>
            <div className="tax-13">
              <label>Address:</label>
              <input
                type="text"
                value={vendorDetails.address}
                className="tax-37"
                readOnly
              />
            </div>
            
            <div className="tax-13">
              <label>GST No:</label>
              <input
                type="text"
                value={vendorDetails.gst_no}
                className="tax-37"
                readOnly
              />
            </div>
          </div>

          <div className="tax-14">
            <div className="tax-13">
              <label>PO No:</label>
              <input
                type="text"
                value={invoiceData.poNo}
                onChange={(e) => updateInvoiceData('poNo', e.target.value)}
                className="tax-37"
              />
            </div>
            <div className="tax-13">
              <label>PO Date:</label>
              <input
                type="date"
                value={invoiceData.poDate}
                onChange={(e) => updateInvoiceData('poDate', e.target.value)}
                className="tax-37"
              />
            </div>
            <div className="tax-13">
              <label>OLA No:</label>
              <input
                type="text"
                value={invoiceData.olaNo}
                onChange={(e) => updateInvoiceData('olaNo', e.target.value)}
                className="tax-37"
              />
            </div>
            
            <div className="tax-13">
              <label>Invoice Date:</label>
              <input
                type="date"
                value={invoiceData.invoiceDate}
                onChange={(e) => updateInvoiceData('invoiceDate', e.target.value)}
                className="tax-37"
              />
            </div>

            <div className="tax-13">
              <label>Performa No:</label>
              <input
                type="text"
                value={invoiceData.invoiceNo}
                onChange={(e) => updateInvoiceData('invoiceNo', e.target.value)}
                className="tax-37"
                readOnly
                style={{ cursor: 'not-allowed' }}
              />
            </div>

            <div className="tax-13">
              <label>Vendor Code:</label>
              <input
                type="text"
                value={vendorDetails.vendorCode}
                onChange={(e) => setVendorDetails(prev => ({
                  ...prev,
                  vendorCode: e.target.value
                }))}
                className="tax-37"
              />
            </div>
          </div>
        </div>

        <div className="tax-16">
          <h3 className="tax-17">Billed To</h3>
          <div className="tax-row">
            <div className="tax-col">
              <div className="tax-18" style={{ position: 'relative' }}>
                <label>Name:</label>
                <input
                  type="text"
                  value={billedTo.name}
                  onChange={(e) => handleBilledToSearch('name', e.target.value)}
                 onFocus={() => {
  setActiveSearchField('gstNo');
  if (searchResults.length > 0) {
    setShowSearchDropdown(true);
  }
}}
                  className="tax-37 full-width"
                  placeholder="Search by name..."
                  autoComplete="off"
                />
                {showSearchDropdown && activeSearchField === 'name' && searchResults.length > 0 && (
                  <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    maxHeight: '200px',
                    overflowY: 'auto',
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                    marginTop: '4px'
                  }}>
                    {searchResults.map((entity, index) => (
                      <div
                        key={index}
                        onClick={() => handleSelectEntity(entity)}
                        style={{
                          padding: '10px',
                          cursor: 'pointer',
                          borderBottom: index < searchResults.length - 1 ? '1px solid #eee' : 'none',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                      >
                        <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                          {entity.name}
                          <span style={{
                            marginLeft: '8px',
                            fontSize: '12px',
                            color: '#666',
                            backgroundColor: entity.type === 'Vendor' ? '#e3f2fd' : '#f3e5f5',
                            padding: '2px 8px',
                            borderRadius: '12px'
                          }}>
                            {entity.type}
                          </span>
                        </div>
                        <div style={{ fontSize: '13px', color: '#666' }}>
                          GST: {entity.gstNo || 'N/A'}
                        </div>
                        {entity.address && (
                          <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
                            {entity.address}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="tax-18">
                <label>Address:</label>
                <input
                  type="text"
                  value={billedTo.address}
                  onChange={(e) => updateBilledTo('address', e.target.value)}
                  className="tax-37 full-width"
                />
              </div>
            </div>
            <div className="tax-col">
              <div className="tax-18" style={{ position: 'relative' }}>
             <label>GST No:</label>
        <input
          type="text"
          value={billedTo.gstNo}
          onChange={(e) => handleBilledToSearch('gstNo', e.target.value)}
          onFocus={() => {
            if (searchResults.length > 0) {
              setShowSearchDropdown(true);
            }
          }}
          className="tax-37 full-width"
          placeholder="Search by GST No..."
          autoComplete="off"
        />
        {showSearchDropdown && activeSearchField === 'gstNo' && searchResults.length > 0 && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            maxHeight: '200px',
            overflowY: 'auto',
            backgroundColor: 'white',
            border: '1px solid #ddd',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 1000,
            marginTop: '4px'
          }}>
            {searchResults.map((entity, index) => (
              <div
                key={index}
                onClick={() => handleSelectEntity(entity)}
                style={{
                  padding: '10px',
                  cursor: 'pointer',
                  borderBottom: index < searchResults.length - 1 ? '1px solid #eee' : 'none',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#f5f5f5'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
              >
                <div style={{ fontWeight: '600', marginBottom: '4px' }}>
                  {entity.name}
                  <span style={{
                    marginLeft: '8px',
                    fontSize: '12px',
                    color: '#666',
                    backgroundColor: entity.type === 'Vendor' ? '#e3f2fd' : '#f3e5f5',
                    padding: '2px 8px',
                    borderRadius: '12px'
                  }}>
                    {entity.type}
                  </span>
                </div>
                <div style={{ fontSize: '13px', color: '#666' }}>
                  GST: {entity.gstNo || 'N/A'}
                </div>
                {entity.address && (
                  <div style={{ fontSize: '12px', color: '#999', marginTop: '2px' }}>
                    {entity.address}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="tax-18">
        <label>Status:</label>
        <select
          value={billedTo.gstStatus}
          onChange={(e) => updateBilledTo('gstStatus', e.target.value)}
          className="tax-37 full-width"
        >
          <option value="Active">Active</option>
          <option value="Cancel">Cancel</option>
        </select>
      </div>
    </div>
  </div>
</div>

        <div className="tax-19">
          <table className="tax-20">
            <thead className="tax-21">
              <tr className="tax-22">
                <th className="tax-23">S.No.</th>
                <th className="tax-24">Description of Work</th>
                <th className="tax-25">Service Code</th>
                <th className="tax-26">UOM</th>
                <th className="tax-27">Rate (Rs.)</th>
                <th className="tax-28">Qty.</th>
                <th className="tax-29">Amount(Rs)</th>
                <th className="tax-30">Action</th>
              </tr>
            </thead>
            <tbody className="tax-31">
              {items.map((item, index) => (
                <tr key={item.id} className="tax-32">
                  <td className="tax-33">{index + 1}</td>
                  <td className="tax-34">
                    <input
                      type="text"
                      value={item.description}
                      onChange={(e) => updateItem(item.id, 'description', e.target.value)}
                      className="tax-35"
                      placeholder="Enter description"
                    />
                  </td>
                  <td className="tax-36">
                    <input
                      type="text"
                      value={item.serviceCode}
                      onChange={(e) => updateItem(item.id, 'serviceCode', e.target.value)}
                      className="tax-37"
                      placeholder="Service Code"
                    />
                  </td>
                  <td className="tax-38">
                    <select
                      value={item.unit}
                      onChange={(e) => updateItem(item.id, 'unit', e.target.value)}
                      className="tax-39"
                    >
                      <option value="EA">EA</option>
                      <option value="Nos">Nos</option>
                      <option value="MTR">MTR</option>
                      <option value="KG">KG</option>
                      <option value="AU">AU</option>
                      <option value="M3">M3</option>
                    </select>
                  </td>
                  <td className="tax-40">
                    <input
                      type="text"
                      value={item.unitPrice}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          updateItem(item.id, 'unitPrice', value);
                        }
                      }}
                      className="tax-41"
                      placeholder="0.00"
                    />
                  </td>
                  <td className="tax-42">
                    <input
                      type="text"
                      value={item.qty}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                          updateItem(item.id, 'qty', value);
                        }
                      }}
                      onBlur={(e) => {
                        const value = e.target.value;
                        const numValue = parseFloat(value);
                        if (!isNaN(numValue) && numValue > 0) {
                          updateItem(item.id, 'qty', numValue);
                        } else {
                          updateItem(item.id, 'qty', 0);
                        }
                      }}
                      className="tax-43"
                      placeholder="1"
                    />
                  </td>
                  <td className="tax-44">₹ {item.amount.toFixed(2)}</td>
                  <td className="tax-45">
                    <button 
                      onClick={() => removeItem(item.id)} 
                      className="tax-46"
                      disabled={items.length === 1}
                    >
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="tax-47">
          <button onClick={addItem} className="tax-48">Add New Item</button>
        </div>

        <div className="tax-49">
          <div className="tax-50">
            <div className="tax-51">
              <p className="tax-52"><strong>Gross Amount:</strong> ₹ {calculations.grossAmount.toFixed(2)}</p>
              <p className="tax-52"><strong>Round Off:</strong> ₹ {calculations.roundOff.toFixed(2)}</p>
              <p className="tax-52"><strong>Rounded Gross Amount:</strong> ₹ {Math.round(calculations.grossAmount).toFixed(2)}</p>
              {isIntraState() ? (
                <>
                  <p className="tax-52"><strong>CGST 9%:</strong> ₹ {calculations.cgst.toFixed(2)}</p>
                  <p className="tax-52"><strong>SGST 9%:</strong> ₹ {calculations.sgst.toFixed(2)}</p>
                </>
              ) : (
                <p className="tax-52"><strong>IGST 18%:</strong> ₹ {calculations.igst.toFixed(2)}</p>
              )}
            </div>
            <div className="tax-53">
              <p className="tax-54"><strong>Taxable Amount: ₹ {calculations.grandTotal.toFixed(2)}</strong></p>
            </div>
          </div>
          </div>

        <div className="tax-65">
          <p className="tax-66">
            <strong>Amount in Words:</strong> {numberToWords(Math.floor(calculations.grandTotal))} Rupees Only
          </p>
        </div>

        <div className="bottom-actions">

          <button onClick={handleBack} className="action-btn back-btn">Back</button>

          <button 
            onClick={handleSave} 
            className="action-btn save-btn"
            disabled={isLoading}
          >
            {isLoading ? (isUpdateMode ? 'Updating...' : 'Saving...') : (isUpdateMode ? 'Save Changes' : 'Submit')}
          </button>
          <button 
            onClick={handleDownload} 
            className="action-btn download-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Downloading...' : 'Download Word'}
          </button>
          {isUpdateMode && (
            <button 
              onClick={resetForm} 
              className="action-btn reset-btn"
            >
              Cancel Update
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformaInvoice;

